import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';
import { CustomerPhotoDialogComponent } from '../payout/customer.photo.dialog.component';

@Injectable()
export class DashboardService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService,
        private httpClient: HttpClient,
        private dialog: MatDialog,
        private constants: Constants) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }


    getManagementDashboardData(type:number,transactionDate: string,dateWiseTransactionDates:string): Observable<any> {

        const params = {
            type:type,
            transactionDate:transactionDate,
            dateWiseTransactionDates:dateWiseTransactionDates
        };

        return this.httpClient.post(this.baseApiUrl + 'dashboard/managementdashboard', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
